// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","fadeIn":"App_fadeIn__3R-bv"};